<template>
  <!-- 领导看板页面 -->
  <div class="billboard">
    <div class="column">
      <div class="summarize">
        <div>
          相关部门所使用的安全管理平台都可以明确地呈现下属机构的安全信息总览。系统通过云平台的大数据分析，将所有数据进行统计分析，让数据分析结果形象、直观地呈现，功能模块间实现交互式常规式可视化导览。
        </div>
      </div>
    </div>
    <div class="column">
      <div class="col_name">大数据平台</div>
      <div class="pre">
        相关部门所使用的安全管理平台都可以明确的呈现下属机构的安全信息总览。系统通过云平台的大数据分析，将所有数据进行统计分析，让数据分析结果形象、直观地呈现，功能模块间实现交互式常规式可视化导览。
      </div>
      <div class="dashed" style="width: 80%">
        <img src="@/assets/images/img19.png" alt="" />
        <!-- <el-image
          style="width: 100px; height: 100px"
          src="@/assets/images/img19.png"
          :preview-src-list="srcList"
        >
        </el-image> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
       srcList: [
          'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
        ]
    }
  }
};
</script>

<style lang="scss">
.summarize {
    padding: 60px;
    background: #ffffff;
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 14px;
    margin-bottom: 100px;
    div {
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #454545;
      line-height: 36px;
      text-align: left;
      text-indent: 2em;
      margin-bottom: 20px;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/solution/billboard.vue